var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('navbar'),_c('main',{staticClass:"py-4"},[_c('router-view',[_c('router-link',{staticClass:"logged-in",attrs:{"to":"/Graphs"}},[_vm._v("Premier League Ratings")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }